module.exports = __webpack_public_path__ + "static/media/quiz-header-logo.b24a3dad.png";